export enum ResponseTypes {
    QR_FIND_ORDER = 1000,
    QR_LOGIN_STAFF = 1001,
    QR_BOX_0 = 1002
}
